const HoursPerMonth = 160;
// const Rates = [0.5156, 0.2476, 0.1214, 0.0631, 0.0243, 0.0291];
const [MonthIncome, Tax, Rent, Office, Depreciation, Administration] = [1, 0.2476, 0.1214, 0.0631, 0.0243, 0.0291];

const Rates = {
  MonthIncome,
  Tax,
  Rent,
  Office,
  Depreciation,
  Administration
};

export default {
  calculate (monthIncome: number, modifiers: HourPrice.Modifiers): HourPrice.Result {
    const values = getValues(monthIncome);

    const result = Object.keys(values).reduce((result, key) => {
      if (key === 'Sum') {
        return result;
      }
      // @ts-ignore
      const hourPrice = round(values[key] / HoursPerMonth);
      // @ts-ignore
      result[key.toLowerCase()] = hourPrice;

      // @ts-ignore
      const rate: number = Rates[key];
      if (modifiers.officeService === false && [Rates.Office, Rates.Rent].includes(rate)) {
        return result;
      }
      if (modifiers.tax === false && rate === Rates.Tax) {
        return result;
      }
      if (modifiers.administration === false && rate === Rates.Administration) {
        return result;
      }
      if (modifiers.depreciation === false && rate === Rates.Depreciation) {
        return result;
      }

      result.hourPrice += hourPrice;
      return result
    }, {hourPrice: 0});

    result.hourPrice = round(result.hourPrice);
    // @ts-ignore
    result.officeService = result.rent + result.office;
    // @ts-ignore
    return result;
  }
}

function getValues (monthIncome: number) {
  return Object.keys(Rates).reduce((values, key) => {
      // @ts-ignore
      const rate: number = Rates[key];
      const cost: number = round(monthIncome * rate);
      // @ts-ignore
      values[key] = cost;
      values.Sum += cost;
      return values
    }, {Sum: 0}
  );
}

function round (number: number) {
  return Math.round(number * 100) / 100;
}
